import React, { useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import axios from "axios";

export default function GuestModal({
  showModal,
  setShowModal,
  editingGuest,
  setEditingGuest,
  formData,
  setFormData,
  clearDraft,
  fetchGuests,
  API_BASE,
  userData
}) {
const isForeignNational =
  formData.nationality &&
  formData.nationality.trim().toLowerCase() !== "india";
  /* ================= HANDLE INPUT CHANGE ================= */

  const handleChange = (e) => {

    const { name, value, type, checked } = e.target;

    const val = type === "checkbox" ? checked : value;

    setFormData((prev) => {

      const updated = {
        ...prev,
        [name]: val
      };

      updated.fullName =
        `${updated.firstName || ""} ${updated.lastName || ""}`.trim();

      return updated;

    });

  };

  /* ================= LOAD EDIT DATA ================= */

  useEffect(() => {

    if (editingGuest) {

      setFormData({
        ...editingGuest,
        dob: editingGuest.dob
          ? editingGuest.dob.substring(0, 10)
          : ""
      });

    }

  }, [editingGuest, setFormData]);

  /* ================= SAVE GUEST ================= */

  const saveGuest = async () => {

    try {

      if (!formData.mobile) {
        alert("Mobile number required");
        return;
      }

      if (editingGuest) {

        await axios.patch(
          `${API_BASE}guests/${userData.branch}/${editingGuest._id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${userData.token}`
            }
          }
        );

      } else {

        await axios.post(
          `${API_BASE}guests/${userData.branch}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${userData.token}`
            }
          }
        );

      }

      fetchGuests();

      clearDraft();       // remove stored draft
      setEditingGuest(null);
      setShowModal(false);

    } catch (error) {

      alert(error.response?.data?.message || "Save failed");

    }

  };

  /* ================= SAFE CLOSE ================= */

  const handleClose = () => {

    const hasData = Object.values(formData).some(
      (v) => v !== "" && v !== null && v !== false && v !== 0
    );

    if (hasData) {

      const confirmClose = window.confirm(
        "You have unsaved guest data. Close anyway?"
      );

      if (!confirmClose) return;

    }

    setShowModal(false);

  };

  return (

<Modal show={showModal} onHide={handleClose} size="lg">

<Modal.Header closeButton>
<Modal.Title>
{editingGuest ? "Edit Guest" : "Add Guest"}
</Modal.Title>
</Modal.Header>

<Modal.Body>

<Form>

<Row>

<Col md={6}>
<Form.Group className="mb-2">
<Form.Label>First Name</Form.Label>
<Form.Control
name="firstName"
value={formData.firstName || ""}
onChange={handleChange}
/>
</Form.Group>
</Col>

<Col md={6}>
<Form.Group className="mb-2">
<Form.Label>Last Name</Form.Label>
<Form.Control
name="lastName"
value={formData.lastName || ""}
onChange={handleChange}
/>
</Form.Group>
</Col>

</Row>

<Row>

<Col md={6}>
<Form.Group className="mb-2">
<Form.Label>Mobile</Form.Label>
<Form.Control
name="mobile"
value={formData.mobile || ""}
onChange={handleChange}
/>
</Form.Group>
</Col>

<Col md={6}>
<Form.Group className="mb-2">
<Form.Label>Email</Form.Label>
<Form.Control
name="email"
value={formData.email || ""}
onChange={handleChange}
/>
</Form.Group>
</Col>

</Row>

<Row>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>Gender</Form.Label>
<Form.Select
name="gender"
value={formData.gender || ""}
onChange={handleChange}
>
<option value="">Select</option>
<option value="Male">Male</option>
<option value="Female">Female</option>
<option value="Other">Other</option>
</Form.Select>
</Form.Group>
</Col>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>Date of Birth</Form.Label>
<Form.Control
type="date"
name="dob"
value={formData.dob || ""}
onChange={handleChange}
/>
</Form.Group>
</Col>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>Pincode</Form.Label>
<Form.Control
name="pincode"
value={formData.pincode || ""}
onChange={handleChange}
/>
</Form.Group>
</Col>

</Row>

<Form.Group className="mb-2">
<Form.Label>Address</Form.Label>
<Form.Control
name="address"
value={formData.address || ""}
onChange={handleChange}
/>
</Form.Group>

<Row>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>City</Form.Label>
<Form.Control
name="city"
value={formData.city || ""}
onChange={handleChange}
/>
</Form.Group>
</Col>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>State</Form.Label>
<Form.Control
name="state"
value={formData.state || ""}
onChange={handleChange}
/>
</Form.Group>
</Col>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>Country</Form.Label>
<Form.Control
name="country"
value={formData.country}
defaultValue={"India"}
onChange={handleChange}
/>
</Form.Group>
</Col>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>Nationality</Form.Label>
<Form.Control
name="nationality"
value={formData.nationality}
onChange={handleChange}
/>
</Form.Group>
</Col>

</Row>

<hr/>

<h6>ID Proof</h6>

<Row>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>ID Type</Form.Label>
<Form.Select
name="idProofType"
value={formData.idProofType || ""}
onChange={handleChange}
>
<option value="">Select</option>
<option>Aadhar</option>
<option>Passport</option>
<option>Driving License</option>
<option>Voter ID</option>
</Form.Select>
</Form.Group>
</Col>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>ID Number</Form.Label>
<Form.Control
name="idProofNumber"
value={formData.idProofNumber || ""}
onChange={handleChange}
/>
</Form.Group>
</Col>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>ID File</Form.Label>
<Form.Control type="file" name="idProofFile" />
</Form.Group>
</Col>

</Row>
{/* ================= FOREIGN NATIONAL DETAILS ================= */}

{isForeignNational && (

<>
<hr />
<h6>Foreign National Details</h6>

<Row>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>Passport Number</Form.Label>
<Form.Control
name="passportNumber"
value={formData.passportNumber || ""}
onChange={handleChange}
/>
</Form.Group>
</Col>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>Passport Issue Country</Form.Label>
<Form.Control
name="passportIssueCountry"
value={formData.passportIssueCountry || ""}
onChange={handleChange}
/>
</Form.Group>
</Col>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>Passport Expiry Date</Form.Label>
<Form.Control
type="date"
name="passportExpiry"
value={formData.passportExpiry || ""}
onChange={handleChange}
/>
</Form.Group>
</Col>

</Row>


<Row>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>Visa Number</Form.Label>
<Form.Control
name="visaNumber"
value={formData.visaNumber || ""}
onChange={handleChange}
/>
</Form.Group>
</Col>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>Visa Type</Form.Label>
<Form.Control
name="visaType"
value={formData.visaType || ""}
onChange={handleChange}
/>
</Form.Group>
</Col>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>Visa Expiry</Form.Label>
<Form.Control
type="date"
name="visaExpiry"
value={formData.visaExpiry || ""}
onChange={handleChange}
/>
</Form.Group>
</Col>

</Row>


<Row>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>Arrival Date in India</Form.Label>
<Form.Control
type="date"
name="arrivalDateIndia"
value={formData.arrivalDateIndia || ""}
onChange={handleChange}
/>
</Form.Group>
</Col>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>Arrival From Country</Form.Label>
<Form.Control
name="arrivalFromCountry"
value={formData.arrivalFromCountry || ""}
onChange={handleChange}
/>
</Form.Group>
</Col>

<Col md={4}>
<Form.Group className="mb-2">
<Form.Label>Arrival Flight No</Form.Label>
<Form.Control
name="arrivalFlight"
value={formData.arrivalFlight || ""}
onChange={handleChange}
/>
</Form.Group>
</Col>

</Row>

</>

)}
<hr/>

<Row>

<Col md={4}>
<Form.Check
type="checkbox"
label="VIP Guest"
name="vipStatus"
checked={formData.vipStatus || false}
onChange={handleChange}
/>
</Col>

<Col md={4}>
<Form.Check
type="checkbox"
label="Blacklisted"
name="blacklisted"
checked={formData.blacklisted || false}
onChange={handleChange}
/>
</Col>

<Col md={4}>
<Form.Group>
<Form.Label>Loyalty Points</Form.Label>
<Form.Control
type="number"
name="loyaltyPoints"
value={formData.loyaltyPoints || 0}
onChange={handleChange}
/>
</Form.Group>
</Col>

</Row>

<Form.Group className="mt-2">
<Form.Label>Special Requests</Form.Label>
<Form.Control
name="specialRequests"
value={formData.specialRequests || ""}
onChange={handleChange}
/>
</Form.Group>

<Form.Group className="mt-2">
<Form.Label>Notes</Form.Label>
<Form.Control
as="textarea"
rows={3}
name="notes"
value={formData.notes || ""}
onChange={handleChange}
/>
</Form.Group>

</Form>

</Modal.Body>

<Modal.Footer>

<Button variant="secondary" onClick={handleClose}>
Cancel
</Button>

<Button onClick={saveGuest}>
Save Guest
</Button>

</Modal.Footer>

</Modal>

  );

}